export const $_app_letter = {
  status: {
    new: "START",
    barcode_requested: "REQUEST",
    wait_envelope: 'WAITENVELOPE',
    barcode_ready: "RESPONSE",
    ready: "READY",
    prepared_to_registry: "PREREESTR",
    in_registry: "INREESTR",
    response_error: "RESPONSE_ERROR"
  }
}

export default $_app_letter

//     START - Новый
//     REQUEST - Был отправлен запрос на формирование уведомления, конверта и бар-кода
//     RESPONSE - Конверт, уведомление и бар-код сформированы
//     READY - Список документов готов и передан в список для формирования реестра
//     PREREESTR - Список документов отмечен для передачи в реестр
//     INREESTR - Документы добавлены в реестр
//     RESPONSE_ERROR - Ошибка формирования конверта

export const $_reestr_status = {
  START: "START",
	REQUEST: "REQUEST",
	WAITREESTR: "WAITREESTR",
	RESPONSE: "RESPONSE",
  READY: "READY"
}

// START(0, "Новое"),
// REQUEST(1, "Сделан запрос"),
// WAITREESTR(4,"Ожидает формирования"),
// RESPONSE(2, "Получен ответ"),
// READY(3, "Распечатано");